import { Link } from 'react-router-dom';
import React from 'react';
import * as routeLookup from 'App/common/routeLookup';

function EhrProviderNotFoundSection() {
    return (
        <div data-testid="ehr-provider-id-missing" className="text-danger">
            The encounter note cannot be sent until your EHR Provider ID is entered.{' '}
            <Link to={{ pathname: routeLookup.myAccountRoute, search: 'sendBackAfterSave=true' }}>
                Click here to update.
            </Link>
        </div>
    );
}

export default EhrProviderNotFoundSection;
